import Contact from "view3/ContactForm.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

const ContactContainer = connectFunction(mapStateToProps)(Contact);
export default ContactContainer;
